import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/Logo Original Blanco.png';
import './NavBar.css';
import CartIndicator from './CartIndicator';

function NavBar({ lang, setLang }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Collapse menu when resizing to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 700) setOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const labels = {
    es: {
      home: 'Inicio',
      catalogue: 'Catálogo',
      about: 'Sobre Nosotros',
      location: 'Ubicación',
      contact: 'Contacto',
      cart: 'Carrito'
    },
    en: {
      home: 'Home',
      catalogue: 'Catalogue',
      about: 'About Us',
      location: 'Location',
      contact: 'Contact',
      cart: 'Cart'
    }
  }[lang];

  const navLinks = [
    { to: '/', label: labels.home },
    { to: '/catalogue', label: labels.catalogue },
    { to: '/location', label: labels.location },
    { to: '/contact', label: labels.contact },
    { to: '/about', label: labels.about }
  ];

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <img
            src={logo}
            alt="CAMITEX Logo"
            className="navbar-logo"
          />
        </Link>
        <button
          className="navbar-toggle"
          aria-label="Toggle navigation"
          onClick={() => setOpen(o => !o)}
        >
          ☰
        </button>
        <div className="navbar-right">
          <ul className={`navbar-links${open ? ' open' : ''}`}>
            {navLinks.map(link => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className={location.pathname === link.to ? 'active' : ''}
                  onClick={() => setOpen(false)}
                >
                  {link.label}
                </Link>
              </li>
            ))}
            {/* Cart link with label only visible on hover */}
            <li className="cart-nav-item">
              <Link
                to="/cart"
                className={`cart-nav-link ${location.pathname === '/cart' ? 'active' : ''}`}
                onClick={() => setOpen(false)}
              >
                <CartIndicator inline={true} />
                <span className="cart-label">{labels.cart}</span>
              </Link>
            </li>
            {/* Language toggle inside nav for mobile */}
            <li className="navbar-lang-toggle">
              <button
                onClick={() => setLang('es')}
                className={`lang-btn${lang === 'es' ? ' active' : ''}`}
                aria-label="Español"
              >
                ES
              </button>
              <button
                onClick={() => setLang('en')}
                className={`lang-btn${lang === 'en' ? ' active' : ''}`}
                aria-label="English"
              >
                EN
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;